//@flow
import * as Immutable from 'immutable';
import ImmutableModel from './ImmutableModel'; // Make sure you copied this file into your repo
import type { FpPointsLatLngModelType } from './FpBeat';
export const UserVisitTypeEnum = Object.freeze({
    SHIFT_START: 'SHIFT_START',
    SHIFT_END: 'SHIFT_END',
    BREAK: 'BREAK',
    RELOAD: 'RELOAD'
});
export type BeatVisitModelType = {
    breakType: string,
    breaches: Array<FpBreachesModelType>,
    eta: {
        startTime: string,
        transactionTime: string,
        completedTime: string
    },
    id: string,
    outletVisitId: ?string,
    userVisitType: ?$Values<typeof UserVisitTypeEnum>,
    summary: {
        totalTravelDistance: number,
        totalTravelDuration: number,
        revenue?: {
            amount: number,
            currency: string,
            symbol: string
        }
    },
    visitLatLng: FpPointsLatLngModelType,
    visitTravel: {
        timeDistancePair: {
            distance: number,
            duration: number
        },
        polyline: ?string
    }
};

export type FpBreachesModelType = {
    breachValue: number,
    description: string,
    name: string,
    unit: string
};

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class BeatVisit extends ImmutableModel {
    static fromJS(json: BeatVisitModelType): BeatVisit {
        const state: Object = Object.assign({}, json);
        state.breaches = Immutable.List(state.breaches).map(item =>
            FpBreaches.fromJS(item)
        );
        state.visitLatLng = FpPointsLatLng.fromJS(state.visitLatLng);
        return new this(Immutable.Map(state));
    }

    toJS(): BeatVisitModelType {
        return {
            breakType: this.breakType,
            breaches: this.breaches.toArray().map(item => item.toJS()),
            eta: this.eta,
            id: this.id,
            outletVisitId: this.outletVisitId,
            userVisitType: this.userVisitType,
            summary: this.summary,
            visitLatLng: this.visitLatLng.toJS(),
            visitTravel: this.visitTravel
        };
    }

    get breakType(): string {
        return this._state.get('breakType');
    }

    setBreakType(breakType: string): this {
        return this.clone(this._state.set('breakType', breakType));
    }

    get breaches(): Immutable.List<FpBreaches> {
        return this._state.get('breaches');
    }

    setBreaches(breaches: Immutable.List<FpBreaches>): this {
        return this.clone(this._state.set('breaches', breaches));
    }

    get eta(): {
        startTime: string,
        transactionTime: string,
        completedTime: string
    } {
        return this._state.get('eta');
    }

    setEta(eta: {
        startTime: string,
        transactionTime: string,
        completedTime: string
    }): this {
        return this.clone(this._state.set('eta', eta));
    }

    get id(): string {
        return this._state.get('id');
    }

    setId(id: string): this {
        return this.clone(this._state.set('id', id));
    }

    get outletVisitId(): ?string {
        return this._state.get('outletVisitId');
    }

    setOutletVisitId(outletVisitId: ?string): this {
        return this.clone(this._state.set('outletVisitId', outletVisitId));
    }

    get userVisitType(): ?$Values<typeof UserVisitTypeEnum> {
        return this._state.get('userVisitType');
    }

    setUserVisitType(userVisitType: ?$Values<typeof UserVisitTypeEnum>): this {
        return this.clone(this._state.set('userVisitType', userVisitType));
    }

    get summary(): {
        totalTravelDistance: number,
        totalTravelDuration: number,
        revenue?: {
            amount: number,
            currency: string,
            symbol: string
        }
    } {
        return this._state.get('summary');
    }

    setSummary(summary: {
        totalTravelDistance: number,
        totalTravelDuration: number,
        revenue?: {
            amount: number,
            currency: string,
            symbol: string
        }
    }): this {
        return this.clone(this._state.set('summary', summary));
    }

    get visitLatLng(): FpPointsLatLng {
        return this._state.get('visitLatLng');
    }

    setVisitLatLng(visitLatLng: FpPointsLatLng): this {
        return this.clone(this._state.set('visitLatLng', visitLatLng));
    }

    get visitTravel(): {
        timeDistancePair: {
            distance: number,
            duration: number
        },
        polyline: ?string
    } {
        return this._state.get('visitTravel');
    }

    setVisitTravel(visitTravel: {
        timeDistancePair: {
            distance: number,
            duration: number
        },
        polyline: ?string
    }): this {
        return this.clone(this._state.set('visitTravel', visitTravel));
    }
}

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class FpBreaches extends ImmutableModel {
    static fromJS(json: FpBreachesModelType): FpBreaches {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }

    toJS(): FpBreachesModelType {
        return {
            breachValue: this.breachValue,
            description: this.description,
            name: this.name,
            unit: this.unit
        };
    }

    get breachValue(): number {
        return this._state.get('breachValue');
    }

    setBreachValue(breachValue: number): this {
        return this.clone(this._state.set('breachValue', breachValue));
    }

    get description(): string {
        return this._state.get('description');
    }

    setDescription(description: string): this {
        return this.clone(this._state.set('description', description));
    }

    get name(): string {
        return this._state.get('name');
    }

    setName(name: string): this {
        return this.clone(this._state.set('name', name));
    }

    get unit(): string {
        return this._state.get('unit');
    }

    setUnit(unit: string): this {
        return this.clone(this._state.set('unit', unit));
    }
}
